import React, { FC } from 'react';

import { useNavigate } from 'react-router-dom';

import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { useBaseAwardsQuery } from '../../../../../redux/ducks/awards';
import { Award as AwardType } from '../../../../../types/AwardTypes';
import { NavListSelect } from '../../../../components';

type Prop = {
    trophySlug?: string;
};

const TrophySelect: FC<Prop> = ({ trophySlug }) => {
    const navigate = useNavigate();

    const { data: baseAwards = [], isFetching } = useBaseAwardsQuery({});
    const baseAwardsSelectOptions = baseAwards.map((award) => ({ label: award.name, value: award.slug }));
    const baseAward = baseAwards.find((award) => award.slug === trophySlug) as AwardType;
    const selectedAward = baseAward && { label: baseAward.name, value: baseAward.slug };

    const getSelectedAwardValue = (award) => {
        navigate(`/awards/trophies/${award.value}`);
    };

    return selectedAward ? (
        <LoadingDisplay isLoading={isFetching}>
            <NavListSelect
                label="Trophy"
                selected={selectedAward}
                availableOptions={baseAwardsSelectOptions}
                selectFunction={getSelectedAwardValue}
                forceDropDown={true}
                className="award-select"
            />
        </LoadingDisplay>
    ) : (
        <></>
    );
};

export default TrophySelect;
